'use strict';

angular.module('membership')
  .controller('CustomerContactsCtrl', [
    '$scope', 'customerContactsViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel($scope.company);
    }
  ]);
